import moment from 'moment';
import { Mapper } from '@/core/mapper/base-mapper';
import { GetDataExtractionModelResponseDTO } from '@/core/dto/data-extraction';
import { REPORT_NAMES_MAP, REPORT_ACRONYM_KEYS, TOOL_LABELS_MAP, ACTION_PLAN_COLUMNS_MAP } from '@/utils/constants';
import type { CombinedDataExtractionModel } from '@/types';

export class GetDataExtractionModelMapper implements Mapper<CombinedDataExtractionModel> {
	constructor(private readonly data: GetDataExtractionModelResponseDTO) {}

	toDomain(): CombinedDataExtractionModel {
		return {
			...this.data,
			author_id: this.data.author_id,
			content: this.data.content,
			start_date: this.data.start_date ? moment(this.data.start_date) : null,
			end_date: this.data.end_date ? moment(this.data.end_date) : null,
			custom_report_id: this.data.custom_report_id,
			has_action_plan_extraction: this.data.has_action_plan_extraction,
			data_extraction_tools: this.data.data_extraction_tools?.map((tool) => ({
				ergonomic_tool_id: tool.ergonomic_tool_id,
				title: TOOL_LABELS_MAP[tool.title] || tool.title
			})),
			custom_report: this.data.custom_report
				? {
						name: REPORT_NAMES_MAP[this.data.custom_report.name] || this.data.custom_report.name,
						acronym: this.data.custom_report.acronym
				  }
				: undefined,
			action_plan_columns: this.data.action_plan_columns?.columns
				? {
						columns: this.data.action_plan_columns.columns.map(
							(column) => ACTION_PLAN_COLUMNS_MAP[column] || column
						)
				  }
				: undefined,
			extraction_name: this.data.extraction_name,
			action_plan_origins: this.data.action_plan_origins?.map((origin) => ({
				custom_report_id: origin.custom_report_id,
				custom_report_name: REPORT_ACRONYM_KEYS[origin.custom_report_name] || origin.custom_report_name
			}))
		};
	}
}
